import * as React from 'react';
import { translate } from '@data/translations';
import { Reservation } from '../resController';
import { ReservationStatus, TaskManagementItemModel } from '@common/modelDefinition';

import { taskTemplateObject } from '@pages/householdNew/taskTemplates';
import { createReservationTaskItem, getTaskItemsByReservationId } from '@pages/newReservations/api';
import { TaskStatusEnum } from '@pages/householdNew/interfaces';
import useStore from '@data/state/zustand';
import ConfirmButtons from '@components/buttons/confirmButtons';
import FolderBox from '@components/documentTools/folderBoxV2';

interface HouseholdTaskProps {
    reservation: Reservation;
    history: any;
    roomInfoId?: number | null;
}

function HouseholdTask(props: HouseholdTaskProps) {
    const { reservation } = props;
    const [newTask, setNewTask] = React.useState<TaskManagementItemModel | null>(null);
    const [reservationTaskItems, setReservationTaskItems] = React.useState<TaskManagementItemModel[]>([]);
    const loggedUser = useStore?.getState()?.authTokenInfo?.user;

    React.useEffect(() => {
        const loadTaskiItems = async () => {
            if (reservation && reservation.id && !newTask) {
                const _reservationTaskItems = await getTaskItemsByReservationId(reservation.id);
                setReservationTaskItems(_reservationTaskItems);
            }
        };
        loadTaskiItems().catch((err) => {
            console.log(err);
        });
    }, [reservation, newTask]);

    return (
        <div className="reservation-inner-height">
            {newTask ? (
                <div className="">
                    <div className="mr-8p">
                        <label>
                            <b>{translate('Title')}</b>
                        </label>
                        <input
                            autoFocus
                            type="text"
                            onChange={(e) => {
                                if (newTask) {
                                    const newCreateNewTask: TaskManagementItemModel = { ...newTask };
                                    newCreateNewTask.taskTitle = e.target.value;
                                    setNewTask(newCreateNewTask);
                                }
                            }}
                            value={newTask?.taskTitle ? newTask.taskTitle : ''}
                            className="form-control"
                        />
                    </div>

                    <div className="mt-12p mr-8p">
                        <label>
                            <b>{translate('Message')}</b>
                        </label>
                        <textarea
                            onChange={(e) => {
                                if (newTask) {
                                    const newCreateNewTask: TaskManagementItemModel = { ...newTask };
                                    newCreateNewTask.taskContent = e.target.value;
                                    setNewTask(newCreateNewTask);
                                }
                            }}
                            value={newTask?.taskContent ? newTask.taskContent : ''}
                            className="form-control"
                        />
                    </div>

                    <br />
                    <div className="mt-12p display-flex justify-content-center">
                        <ConfirmButtons
                            onConfirm={async () => {
                                if (newTask && reservation.id && reservation.roomInfoId) {
                                    const _newTask = { ...newTask };
                                    _newTask.reservationId = reservation.id;
                                    _newTask.roomInfoId = reservation.roomInfoId;
                                    _newTask.taskGroup = 'reservationTask';
                                    _newTask.userCreated = loggedUser.uuid; // ovdje
                                    await createReservationTaskItem(_newTask, reservation);
                                    setNewTask(null);
                                }
                            }}
                            onCancel={() => {}}
                            doNotShowCancel={true}
                            confirmText={'Save'}
                        />
                    </div>
                </div>
            ) : (
                <div>
                    <div className="display-flex">
                        {reservation?.statusEnum !== ReservationStatus.closed ? (
                            <div
                                onClick={() => {
                                    setNewTask(taskTemplateObject);
                                }}
                                className="button-primary mt-16p"
                            >
                                {translate('New task')}
                            </div>
                        ) : null}
                    </div>
                    <div className="custom-list-header mt-10p">
                        <div>{translate('Title')}</div>
                        <div>{translate('Description')}</div>
                        <div>{translate('Status')}</div>
                        <div>{translate('Photo')}</div>
                    </div>
                    <div className="mt-16p color-sucess">
                        {reservationTaskItems.map((t) => {
                            if (t.taskGroup === 'reservationTask') {
                                return (
                                    <div key={t.id} className="custom-list-item mb-4p" id="no-hover">
                                        <div>{t.taskTitle}</div>
                                        <div>{t.taskContent}</div>
                                        <div>{translate(TaskStatusEnum[t.taskStatus as TaskStatusEnum])}</div>
                                        {t?.userArguments ? (
                                            <div>
                                                <FolderBox
                                                    selectOptions={[]}
                                                    category={''}
                                                    documents={t?.userArguments}
                                                    showDeleteButton={false}
                                                    showFileUploadButton={false}
                                                    dontShowDocumentName={true}
                                                />
                                            </div>
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}

export default HouseholdTask;
